import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

import userReducer from '@domagude/nospen-packages/frontend/redux/user/userSlice';
import modalsReducer from '@domagude/nospen-packages/frontend/redux/modals/modalsSlice';
import exchangeReducer from '@domagude/nospen-packages/frontend/redux/exchange/exchangeSlice';
import topBarReducer from '@domagude/nospen-packages/frontend/redux/topBar/topBarSlice';
import listAnAssetReducer from '@domagude/nospen-packages/frontend/redux/listAnAsset/listAnAssetSlice';
import searchAssetsReducer from '@domagude/nospen-packages/frontend/redux/searchAssets/searchAssetsSlice';
import profilePageReducer from '@domagude/nospen-packages/frontend/redux/profilePage/profilePageSlice';
import secondaryProfilePageReducer from '@domagude/nospen-packages/frontend/redux/secondaryProfilePage/secondaryProfilePageSlice';
import followingPageReducer from '@domagude/nospen-packages/frontend/redux/followingPage/index';
import accountSettingsReducer from '@domagude/nospen-packages/frontend/redux/accountSettingsPage/accountSettingsSlice';
import chatsPageReducer from '@domagude/nospen-packages/frontend/redux/chatsPage/chatsPageSlice';
import featureFlagsReducer from '@domagude/nospen-packages/frontend/redux/featureFlags/featureFlagsSlice';
import clubsReducer from '@domagude/nospen-packages/frontend/redux/clubs/clubsSlice';
import contactsReducer from '@domagude/nospen-packages/frontend/redux/contacts/contactsSlice';
import cookieConsentReducer from './cookieConsent/cookieConsentSlice';
import appDownloadBannerReducer from './appDownloadBanner/appDownloadBannerSlice';

const rootReducer = combineReducers({
  user: userReducer,
  modals: modalsReducer,
  exchange: exchangeReducer,
  topBar: topBarReducer,
  listAnAsset: listAnAssetReducer,
  searchAssets: searchAssetsReducer,
  profilePage: profilePageReducer,
  accountSettings: accountSettingsReducer,
  secondaryProfilePage: secondaryProfilePageReducer,
  followingPage: followingPageReducer,
  chatsPage: chatsPageReducer,
  clubs: clubsReducer,
  contacts: contactsReducer,
  cookieConsent: cookieConsentReducer,
  appDownloadBanner: appDownloadBannerReducer,
  featureFlags: featureFlagsReducer,
});

const persistConfig = { key: 'root', version: 1, storage };
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
